import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioCategoryListPageApi = createApi({
  reducerPath: 'audioCategoryListPageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioCategoryListPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAudioCategoryListData: builder.query({
      query: () => ({
        url : 'https://snsapiv2.baganit.com/api/app/categories/update', //'categories/update',
        method: 'POST',
        body : {
            "phone": "",
            // "platform": "miniapp",
            "udid": "190740e5f0032702",
            "user_id": getLocalStorageData(),
            "version_code": 29,
            "version_name": "1.2.9"
        },
      }), 
    })
  }),
});

export const { useFetchAudioCategoryListDataQuery, endpoints } = audioCategoryListPageApi;